export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/supershop-pos/:pageId',
        component: () => import('@/views/page/company/super-shop/PosInvoice.vue'),
        name: 'supershop-pos',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/supershop-pos-list/:pageId',
        component: () => import('@/views/page/company/super-shop/PosInvoiceList.vue'),
        name: 'supershop-pos-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/reward-point-list/:pageId',
        component: () => import('@/views/page/company/super-shop/RewardPointList.vue'),
        name: 'reward-point-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/reward-point-approval/:pageId',
        component: () => import('@/views/page/company/super-shop/RewardPointApprovalList.vue'),
        name: 'reward-point-approval',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/reward-point-statement/:pageId',
        component: () => import('@/views/page/company/super-shop/RewardPointStatementList.vue'),
        name: 'reward-point-statement',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/reward-points-register/:pageId',
        component: () => import('@/views/page/company/super-shop/RewardPointRegister.vue'),
        name: 'reward-points-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/pos-collection-report/:pageId',
        component: () => import('@/views/page/company/super-shop/PosCollectionReportList.vue'),
        name: 'pos-collection-report-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/reward-point-import/:pageId',
        component: () => import('@/views/page/company/super-shop/ImportRewardPointList.vue'),
        name: 'reward-point-import',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/upload-reward-point/:pageId',
        component: () => import('@/views/page/company/super-shop/UploadRewardPoint.vue'),
        name: 'upload-reward-point',
        meta: {
            requiresAuth: true
        }
    },
]